import React, {Component} from "react";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import {ACTIVITY_TYPE, HttpStatus} from "../../../common/Constants";
import FlexView from "react-flexview";
import {formGroup, getTableConfig} from "../config";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import {defaultTableChange} from "../../../../modules/custom/customTable";
import MasterVoucherFilter from "./masterVoucherFilter";
import Button from "../../../../modules/commons/Button";
import MasterVoucherModifying from "./masterVoucherModifying";
import MasterVoucherUser from "./masterVoucherUser";
import Api from "../../../../Services/Api";
import ErrorAction from "../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {flattenFormGroupObject, mapToObjectDDL, removeNullFields} from "../../../common/mapper";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import {fetchDataAsync} from "../../../../Services/Utils";

class MasterVoucherTab extends Component {
    actionsColumn = {
        master: [
            {
                name: "voucherId",
                label: "Aksi",
                options: {
                    customBodyRender: (val, {rowIndex}) => {
                        return (
                            <FlexView vAlignContent="center" style={{gap: 15}}>
                                <SimpleButton
                                    category="action_button"
                                    style={{backgroundColor: "transparent"}}
                                    icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-eye"/>}
                                    onClick={() => this.handleModifyingVisibility(ACTIVITY_TYPE.VIEW, val)}
                                />
                                <SimpleButton
                                    category="action_button"
                                    style={{backgroundColor: "transparent"}}
                                    icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-lw fa-pencil-alt"/>}
                                    onClick={() => this.handleModifyingVisibility(ACTIVITY_TYPE.UPDATE, val)}
                                />
                                <SimpleButton
                                    category="action_button"
                                    style={{backgroundColor: "transparent"}}
                                    icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-copy"/>}
                                    onClick={() => this.handleModifyingVisibility(ACTIVITY_TYPE.COPY, val)}
                                />
                                <SimpleButton
                                    category="action_button"
                                    style={{backgroundColor: "transparent"}}
                                    icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-trash"/>}
                                    onClick={() => this.handleShowAlert(val)}
                                />
                                
                            </FlexView>
                        )
                    }
                }
            },
        ],
        user: [
            {
                name: "kodeVoucher",
                label: "Aksi",
                options: {
                    customBodyRender: (val) => {
                        return (
                            <FlexView vAlignContent="center">
                                <SimpleButton
                                    category="action_button"
                                    style={{backgroundColor: "transparent"}}
                                    icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-eye"/>}
                                    onClick={() => this.handleUserVoucherVisibility(val)}
                                />
                            </FlexView>
                        )
                    }
                }
            }
        ],
    };

    constructor(props) {
        super(props);
        this.state = {
            errorNameVisible: false,
            loading: false,
            modifyingVisible: false,
            filterVisible: false,
            userVoucherVisible: false,
            activityType: null,
            selectedData: null,
            dataUserVoucher: null,
            dataTable: [],
            tableConfig: [],
            ddlOptions: {
                partOptions: [],
                jobOptions: [],
                partCategoryOptions: [],
                jobCategoryOptions: [],
            },
            deleteId: "",
            submittedFilter: {},
            pagination: {
                totalData: 0,
                limit: 5,
                page: 1,
            },
            isFetch: false,
            alertCannotDelete: false,
        };
    };

    async componentDidMount() {
        this.handleTriggerLoading();
        this.setState((prevValue) => ({
            ...prevValue,
            tableConfig: [
                ...getTableConfig(this.props.tab),
                ...this.actionsColumn[this.props.tab],
            ],
        }));
        await this.fetchData();
        this.handleTriggerLoading();
        this.fetchDataPart();
        this.fetchCategoryPart();
    };

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if ((prevState.pagination.page !== this.state.pagination.page
                || prevState.pagination.limit !== this.state.pagination.limit)
            && !this.state.isFetch) {
            this.handleTriggerLoading();
            await this.fetchData(
                this.state.submittedFilter,
                this.state.pagination.page,
                this.state.pagination.limit,
            );
            this.handleTriggerLoading();
        }
    }

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        this.setState((prevValue) => ({...prevValue, isFetch: true}));
        let request = removeNullFields({
            ...filter,
            voucherType: filter?.voucherType?.value,
            subVoucherType: filter?.subVoucherType?.value,
            availibility: filter?.availibility?.value,
        })
        if (this.props.tab === "master") {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getTabMasterVoucher,
                menuName: "Master Voucher",
                setError: this.props.setError,
                args: {
                    ...request,
                    limit,
                    page,
                },
            });
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                await this.setState((prevValue) => ({
                    ...prevValue,
                    dataTable: res.data.data,
                    pagination: {
                        ...prevValue.pagination,
                        totalData: res.data.totalData,
                        page,
                        limit,
                    },
                }));
            }
        }
        this.setState((prevValue) => ({...prevValue, isFetch: false}));
    };

    handleShowAlert = (id) => {
        if (id) {
            this.setState((prevValue) => ({...prevValue, deleteId: id}));
        } else {
            this.setState((prevValue) => ({...prevValue, deleteId: "",}));
        }
    };

    handleShowAlertCannotDelete = () => {
        this.setState((prevValue) => ({...prevValue, alertCannotDelete: !prevValue.alertCannotDelete}));
    };

    handleDelete = async () => {
        this.handleTriggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").deleteByVoucherId,
            menuName: "Master Voucher",
            setError: this.props.setError,
            args: this.state.deleteId,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleShowAlert();
            await this.refetch();
        }
        if (res.data.code === 509) {
            this.handleShowAlert();
            this.handleShowAlertCannotDelete();
        }
        this.handleTriggerLoading();
    };

    fetchDataPart = async () => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterPart({paramFilters: {}});
            if (response.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    ddlOptions: {
                        ...prevValue.ddlOptions,
                        partOptions: response.data.data,
                    },
                }));
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchCategoryPart = async () => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam({
                paramFilters: {
                    bizparCategory: "PART_TYPE",
                }
            });
            if (response.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    ddlOptions: {
                        ...prevValue.ddlOptions,
                        partCategoryOptions: response.data.data,
                    },
                }));
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: tableState.page + 1,
            },
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                page: 1,
                totalData: 1,
                limit: tableState.rowsPerPage,
            },
        }));
    };

    handleFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: !prevValue.filterVisible
        }));
    };

    refetch = async () => {
        await this.fetchData(
            this.state.submittedFilter,
            this.state.pagination.page,
            this.state.pagination.limit,
        );
    };

    handleModifyingVisibility = async (at, id) => {
        this.handleTriggerLoading();
        if (id) {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getByVoucherId,
                menuName: "Master Voucher",
                setError: this.props.setError,
                args: id,
            });
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                if (res.data.status === HttpStatus.FAILED) {
                    this.props.setError({
                        menuName: "Master Voucher",
                        errorMessage: res.data.message,
                    });
                }
                let data = res.data.data;
                let listData = data?.voucherType === "BENGKEL" && data?.subVoucherType === "PART" && data?.applicableJob === "SPESIFIK"
                    ? data.spesificJobPart.map(item => ({
                        id: item.id,
                        voucherWorkshopSpesificJobId: item.voucherWorkshopSpesificJobId,
                        jobPartCode: item.dataPart.kodePart,
                        partName: item.dataPart.partName,
                        partCategory: item.dataPart.partCategory.value,
                        unit: item.unit,
                        value: item.value,
                        saved: true,
                    }))
                    : data?.voucherType === "BENGKEL" && data?.subVoucherType === "JOB" && data?.applicableJob === "SPESIFIK"
                        ? []
                        : [];
                this.setState((prevValue) => ({
                    ...prevValue,
                    activityType: at,
                    modifyingVisible: !prevValue.modifyingVisible,
                    errorNameVisible: false,
                    selectedData: {
                        ...data,
                        discountUnit: mapToObjectDDL(data?.discountUnit, data?.discountUnit),
                        spesificJobPart: listData,
                    },
                }));
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: null,
                activityType: at,
                modifyingVisible: !prevValue.modifyingVisible,
                errorNameVisible: false,
            }));
        }
        this.handleTriggerLoading();
    };

    handleUserVoucherVisibility = async (id) => {
        if (id) {
            const response = this.dummyUserVoucher[0]
            this.setState((prevValue) => ({
                ...prevValue,
                userVoucherVisible: !prevValue.userVoucherVisible,
                dataUserVoucher: response,
            }));
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                dataUserVoucher: null,
                userVoucherVisible: !prevValue.userVoucherVisible,
            }));
        }
    }

    handleErrorNameVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            errorNameVisible: false,
        }));
    };

    handleSubmitFilter = async (filter) => {
        this.handleTriggerLoading();
        this.handleFilterVisibility();
        this.setState((prevValue) => ({...prevValue, submittedFilter: filter}));
        await this.fetchData(filter, 1, this.state.pagination.limit);
        this.handleTriggerLoading();
    };

    handleSubmitModifying = async (controls) => {
        this.handleTriggerLoading();
        const formData = flattenFormGroupObject(controls);
        const {voucherPictureBase64, spesificJobPart, ...rest} = formData;
        let jobPart =
            spesificJobPart === null || spesificJobPart[0] === null
                ? []
                : spesificJobPart.map((item) => {
                    let {partName, partCategory, value, saved, ...rest} = item;
                    return {...rest, value: parseInt(value, 10)};
                });
        let request = {
            ...rest,
            voucherId:
                this.state.activityType === ACTIVITY_TYPE.CREATE ||
                this.state.activityType === ACTIVITY_TYPE.COPY
                    ? null
                    : formData.voucherId,
            voucherPictureUrl: formData.voucherPictureBase64,
            discountUnit: formData?.discountUnit?.value || null,
            spesificJobPart: jobPart,
            discountValue: rest?.discountValue || 0,
        };

        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").checkExistingVoucherName,
            menuName: "Master Voucher",
            setError: this.props.setError,
            args: request.voucherName,
        });
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            if (response.data.data === true && (this.state.activityType === ACTIVITY_TYPE.CREATE || this.state.activityType === ACTIVITY_TYPE.COPY)) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    errorNameVisible: true,
                }));
            } else {
                let res = await fetchDataAsync({
                    asyncFn: Api.create("NAGAMAS_MASTER_DATA").saveAndUpdateVoucher,
                    menuName: "Master Voucher",
                    setError: this.props.setError,
                    args: request,
                });
                if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                    this.handleModifyingVisibility();
                    await this.refetch();
                }
            }
        }
        this.handleTriggerLoading();
    };

    render() {
        return (
            <>
                <FlexView style={{justifyContent: "end"}}>
                    <Button
                        type="button"
                        className="btn background-red margin-bottom-20px"
                        onClick={this.handleFilterVisibility}
                    >
              <span>
                <i className="fa fa-qrcode"></i>
              </span>
                    </Button>
                </FlexView>
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableConfig}
                    toCount={this.state.pagination.totalData}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={defaultTableChange(this.handleChangePage, this.handleRowsPerPage)}
                    footerAdditionalButtons={
                        <>
                            {this.props.tab === "master" && (
                                <SimpleButton
                                    icon={<i className="fa fa-plus margin-right-10px"></i>}
                                    onClick={() => this.handleModifyingVisibility(ACTIVITY_TYPE.CREATE)}
                                >
                                    Tambah
                                </SimpleButton>
                            )}
                        </>
                    }
                />
                {this.state.filterVisible && (
                    <MasterVoucherFilter
                        {...this.props}
                        submittedFilter={this.state.submittedFilter}
                        visible={this.state.filterVisible}
                        onClickClose={this.handleFilterVisibility}
                        onSubmit={this.handleSubmitFilter}
                    />
                )}
                {this.state.modifyingVisible && (
                    <MasterVoucherModifying
                        {...this.props}
                        formGroup={formGroup}
                        options={this.state.ddlOptions}
                        initialValues={this.state.selectedData}
                        visible={this.state.modifyingVisible}
                        errorNameVisible={this.state.errorNameVisible}
                        onClickClose={() => this.handleModifyingVisibility(null)}
                        activityType={this.state.activityType}
                        onSubmit={this.handleSubmitModifying}
                        onClickOkError={this.handleErrorNameVisibility}
                    />
                )}
                {this.state.userVoucherVisible && (
                    <MasterVoucherUser
                        visible={this.state.userVoucherVisible}
                        onClickClose={this.handleUserVoucherVisibility}
                        data={this.state.dataUserVoucher}
                    />
                )}
                {this.state.deleteId !== "" && (
                  <SimpleAlert
                    visible={this.state.deleteId !== ""}
                    onClickClose={() => this.handleShowAlert()}
                    content={
                        <div>
                            <p>Apakah anda yakin ingin menghapus data {this.state.deleteId} ?</p>
                        </div>
                    }
                    additionalButtons={
                        <FlexView vAlignContent="center" style={{gap: "10px"}}>
                            <SimpleButton secondary onClick={() => this.handleShowAlert()}>
                                Batal
                            </SimpleButton>
                            <SimpleButton onClick={this.handleDelete}>Iya</SimpleButton>
                        </FlexView>
                    }/>
                )}
                {this.state.alertCannotDelete && (
                  <SimpleAlert
                    visible={this.state.alertCannotDelete}
                    onClickClose={() => this.handleShowAlertCannotDelete()}
                    content={
                        <div>
                            <p>Data tidak dapat dihapus, sudah masuk kedalam transaksi.</p>
                        </div>
                    }
                    additionalButtons={
                        <FlexView vAlignContent="center" style={{gap: "10px"}}>
                            <SimpleButton onClick={() => this.handleShowAlertCannotDelete()}>
                                OK
                            </SimpleButton>
                        </FlexView>
                    }/>
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterVoucherTab);